module.exports = __webpack_public_path__ + "img/20190612_132334_023.20eeb5ad.jpg";